import React from 'react';
export function Footer() {
  return <footer className="bg-navy text-white/60 py-10 md:py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-60">
      <div className="max-w-5xl mx-auto text-center" data-id="element-61">
        <div className="mb-6 md:mb-8" data-id="element-62">
          <h2 className="text-xl md:text-2xl font-bold text-white mb-1 md:mb-2 font-serif" data-id="element-63">
            KIT PROFESIONAL POSTPARTO™
          </h2>
          <p className="text-white/80 font-medium text-sm md:text-base" data-id="element-64">
            El sistema de acompañamiento N°1 para profesionales de postparto en
            Argentina.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-8 md:mb-12" data-id="element-65">
          <p className="italic font-serif text-base md:text-lg text-gold/80" data-id="element-66">
            Porque acompañar el postparto no debería costarte todas las noches
            de la semana.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 md:gap-8 text-xs md:text-sm mb-8 md:mb-12" data-id="element-67">
          <a href="mailto:soporte.activadigitalok@gmail.com" className="hover:text-white transition-colors" data-id="element-68">
            soporte.activadigitalok@gmail.com
          </a>
          <span className="hidden md:inline text-white/20" data-id="element-69">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-70">
            @activadigital.store
          </a>
          <span className="hidden md:inline text-white/20" data-id="element-71">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-72">
            activadigital.store
          </a>
        </div>

        <div className="text-[10px] md:text-xs text-white/40 border-t border-white/10 pt-6 md:pt-8" data-id="element-73">
          <p className="mb-1 md:mb-2" data-id="element-74">
            © Activa Digital™ 2026 Todos los derechos reservados.
          </p>
          <p data-id="element-75">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}